import { cloneElement, type ReactElement } from 'react';
import { Text } from '@doist/marketist';
import cn from 'clsx';
import css from './product-ui-category-pill.module.css';
export type ProductUICategoryPillProps = {
  startIcon?: ReactElement;
  children: React.ReactNode;
  variant?: 'primary' | 'outline' | 'tertiary';
};
export function ProductUICategoryPill({
  children,
  variant = 'primary',
  startIcon,
  ...rest
}: ProductUICategoryPillProps) {
  const StartIcon = startIcon ? cloneElement(startIcon, {
    width: 16,
    height: 16
  }) : null;
  return <div className={cn(css.categoryPill, css[variant])} {...rest} data-sentry-component="ProductUICategoryPill" data-sentry-source-file="product-ui-category-pill.tsx">
            {StartIcon}
            <Text size="body-2xs" weight="medium" data-sentry-element="Text" data-sentry-source-file="product-ui-category-pill.tsx">
                {children}
            </Text>
        </div>;
}